module.exports = __webpack_public_path__ + "static/media/padilla-matriz.81e8e30c.jpg";